import type { TweetListResponsePageAllOfThreeContentItemAuth } from './tweetListResponsePageAllOfThreeContentItemAuth';
import type { TweetListResponsePageAllOfThreeContentItemAuthor } from './tweetListResponsePageAllOfThreeContentItemAuthor';
import type { TweetListResponsePageAllOfThreeContentItemBasicInfo } from './tweetListResponsePageAllOfThreeContentItemBasicInfo';
import type { TweetListResponsePageAllOfThreeContentItemEngagement } from './tweetListResponsePageAllOfThreeContentItemEngagement';
import type { TweetListResponsePageAllOfThreeContentItemMedia } from './tweetListResponsePageAllOfThreeContentItemMedia';
import type { TweetListResponsePageAllOfThreeContentItemPoll } from './tweetListResponsePageAllOfThreeContentItemPoll';
import type { TweetListResponsePageAllOfThreeContentItemReferencedTweet } from './tweetListResponsePageAllOfThreeContentItemReferencedTweet';
import type { TweetListResponsePageAllOfThreeContentItemTags } from './tweetListResponsePageAllOfThreeContentItemTags';
import type { TweetListResponsePageAllOfThreeContentItemUserInteraction } from './tweetListResponsePageAllOfThreeContentItemUserInteraction';

export type TweetListResponsePageAllOfThreeContentItem = {
  /** 인증 컨텍스트 정보 */
  auth?: TweetListResponsePageAllOfThreeContentItemAuth;
  /** 트윗 작성자 정보 */
  author?: TweetListResponsePageAllOfThreeContentItemAuthor;
  basicInfo?: TweetListResponsePageAllOfThreeContentItemBasicInfo;
  engagement?: TweetListResponsePageAllOfThreeContentItemEngagement;
  /** 미디어 정보 */
  media?: TweetListResponsePageAllOfThreeContentItemMedia;
  /** 트윗에 포함될 투표 정보 (선택 사항) */
  poll?: TweetListResponsePageAllOfThreeContentItemPoll;
  /** 참조된 트윗 정보 (답글, 인용, 리트윗인 경우) */
  referencedTweet?: TweetListResponsePageAllOfThreeContentItemReferencedTweet;
  /** 트윗 태그 정보 */
  tags?: TweetListResponsePageAllOfThreeContentItemTags;
  /** 사용자 상호작용 정보 */
  userInteraction?: TweetListResponsePageAllOfThreeContentItemUserInteraction;
};
